const FechaInput = ({ name, value, onChange }) => {
    return (
        <input
            type="date"
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            className="filtro-date-input"
        />
    );
};

export default FechaInput;
